(() => {
  const createCollapsible = (el, initial = false) => {
    let isOpen = initial;

    el.style.height = isOpen ? 'auto' : '0';
    el.style.overflow = 'hidden';

    const open = () => {
      if (isOpen) {
        return;
      }
      isOpen = true;

      const currentHeight = getComputedStyle(el).height;
      el.style.height = 'auto';
      const height = getComputedStyle(el).height;
      el.style.height = currentHeight;
      getComputedStyle(el).height;
      requestAnimationFrame(() => {
        el.style.height = height;
      });
    };

    const close = () => {
      if (!isOpen) {
        return;
      }
      isOpen = false;

      const height = getComputedStyle(el).height;
      el.style.height = height;
      getComputedStyle(el).height;
      requestAnimationFrame(() => {
        el.style.height = '0';
      });
    };

    el.style.transition = 'height 300ms ease-in-out';
    el.addEventListener('transitionend', (e) => {
      if (e.target !== el) {
        return;
      }
      if (isOpen) {
        el.style.height = 'auto';
      }
    });

    return {
      open,
      close,
      el
    };
  };

  const formatMoney = (cents, format) => {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || '${{amount}}';

    const defaultOption = (opt, def) => {
      return typeof opt === 'undefined' ? def : opt;
    };

    const formatWithDelimiters = (number, precision, thousands, decimal) => {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const centsValue = parts[1] ? decimal + parts[1] : '';

      return dollars + centsValue;
    };

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  const updatePrice = (el, value, moneyFormat) => {
    if (el == null) {
      return;
    }
    return (el.innerHTML = `<span class="money">${formatMoney(value, moneyFormat)}</span>`);
  };

  const getAllocatedSellingPlanById = (variant, id) => {
    return variant.sellingPlans.find((plan) => plan.id === Number(id));
  };

  const initSellingPlanInput = (form) => {
    let el = form.querySelector('input[name="selling_plan"]');

    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = 'selling_plan';
      form.append(el);
    }

    return el;
  };

  const initWidget = (variants, variantId, moneyFormat) => {
    const widget = document.querySelector('#juo-subscription-widget');
    if (!widget) {
      return;
    }

    const forms = Array.from(document.querySelectorAll('form[action$="/cart/add"]'));
    const sellingPlanInputs = forms.map(initSellingPlanInput);

    const priceElement = widget.querySelector('[part="subscription-price"]');
    const basePriceElement = widget.querySelector('[part="price price--base"]');
    const comparePriceElement = widget.querySelector('[part="compare-price"]');
    const sellingPlanSelectorElement = widget.querySelector('[part="select"]');

    const getMode = () => {
      return widget.querySelector('input[name="mode"]:checked').value;
    };

    const getValue = () => {
      if (getMode() === 'otp') {
        return '';
      }

      return widget.querySelector('select').value;
    };

    const populateSellingPlanId = () => {
      const value = getValue();
      sellingPlanInputs.forEach((sellingPlanInput) => {
        sellingPlanInput.value = value;
      });
    };

    const getActiveVariant = () => {
      const url = new URL(window.location.href);
      const activeVariantId = url.searchParams.get('variant') || variantId;
      return variants.find(({ id }) => id == activeVariantId) || variants.find(Boolean);
    };

    const updateSaveBadge = (comparePrice, price) => {
      const saveBadge = widget.querySelector('[data-ref="save-badge"]');
      const saveElement = widget.querySelector('[data-ref="save"]');

      if (!saveBadge || !saveElement) {
        return;
      }

      const compare = Number(comparePrice) || 0;
      const salePrice = Number(price) || 0;

      if (compare > salePrice) {
        const percentage = (salePrice / compare) * 100;
        saveElement.textContent = `${100 - Math.round(percentage)}`;
        saveBadge.hidden = false;
      } else {
        saveBadge.hidden = true;
      }
    };

    const updateSellingPlans = (sellingPlans = [], activeVariantId) => {
      if (sellingPlanSelectorElement.dataset.activeVariant === String(activeVariantId)) {
        return;
      }

      let html = '';
      sellingPlans.forEach((plan) => {
        html += `<option value="${plan.id}">${plan.name}</option>`;
      });
      sellingPlanSelectorElement.innerHTML = html;

      if (sellingPlans.length === 0) {
        sellingPlanSelectorElement.value = '';
        return;
      }

      sellingPlanSelectorElement.dataset.activeVariant = activeVariantId;
      sellingPlanSelectorElement.value = sellingPlanSelectorElement?.children[0].value;
      populateSellingPlanId();
    };

    const updateView = () => {
      const activeVariant = getActiveVariant();
      const allocatedPlan = getAllocatedSellingPlanById(activeVariant, sellingPlanSelectorElement.value);

      updateSellingPlans(activeVariant.sellingPlans, activeVariant.id);

      if (allocatedPlan == null) {
        widget?.classList.add('juo-hidden');
        return;
      } else {
        widget?.classList.remove('juo-hidden');
      }

      updateSaveBadge(allocatedPlan.comparePrice, allocatedPlan.price);

      updatePrice(basePriceElement, activeVariant.price, moneyFormat);
      updatePrice(priceElement, allocatedPlan.price, moneyFormat);
      if (allocatedPlan.price < allocatedPlan.comparePrice && activeVariant.price !== allocatedPlan.price) {
        updatePrice(comparePriceElement, allocatedPlan.comparePrice, moneyFormat);
      } else if (comparePriceElement) {
        comparePriceElement.innerHTML = '';
      }
    };

    const collapsibleEl = widget.querySelector('.collapsible');
    const collapsible = collapsibleEl == null ? null : createCollapsible(collapsibleEl, getMode() === 'subscription');

    const update = () => {
      populateSellingPlanId();
      updateView();

      if (collapsible) {
        if (getMode() === 'subscription') {
          collapsible.open();
        } else {
          collapsible.close();
        }
      }
    };

    update();
    document.addEventListener('change', update);
    sellingPlanSelectorElement.addEventListener('change', () => {
      widget.querySelector('input[name="mode"][value="subscription"]').click();
    });
  };

  const main = () => {
    if (window.Shopify != null) {
      const init = () => {
        const [variants, variantId, moneyFormat] = JSON.parse(
          document.getElementById('juo-subscription-widget-data')?.innerText ?? '[]'
        );

        initWidget(variants, variantId, moneyFormat);
      };

      if (document.readyState === 'complete' || document.readyState === 'interactive') {
        init();
      } else {
        document.addEventListener('DOMContentLoaded', init);
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main);
  } else {
    main();
  }
})();
